module.exports = __webpack_public_path__ + "img/menu_mobile.b4c67ee4.svg";